import { useEffect, useState } from 'react';
import { useApi, useCurrentUser } from 'lib/contexts/ApplicationState';
import { MilestoneCardModal } from 'components/MilestoneCardModal';
import { Milestone } from 'lib/types';
import { CelebrateModal } from './CelebrateModal';

export const Celebrate = () => {
  const API = useApi();
  const currentUser = useCurrentUser();

  const [milestoneStep, setMilestoneStep] = useState(0);
  const [milestone, setMilestone] = useState<Milestone | undefined>(undefined);

  const getStep = () => {
    if (milestoneStep === 1) {
      return <CelebrateModal onClose={() => setMilestoneStep(2)} />;
    }

    if (milestoneStep === 2 && milestone) {
      return (
        <MilestoneCardModal
          img={milestone?.cardUrl}
          onClose={() => setMilestoneStep(0)}
          milestone={milestone}
        />
      );
    }

    return null;
  };

  useEffect(() => {
    const getMilestoneNotification = async () => {
      try {
        const topMilestone = await API.getTopNewMilestoneForUser();
        setMilestoneStep(topMilestone ? 1 : 0);
        setMilestone(topMilestone);
      } catch (err: any) {
        //no op
      }
    };

    if (currentUser) {
      getMilestoneNotification();
      const intervalId = setInterval(getMilestoneNotification, 300000); // 5 minutes
      return () => clearInterval(intervalId);
    }

    return undefined;
  }, [currentUser]);

  return getStep();
};
